.badges {
    display: flex;
    gap: var(--spacer-8);
    margin-top: var(--spacer-12);
}
